interface Revolutions {
  locale: string;
  data: {
    title: string;
    content: string;
    button: string;
  };
}
export  default  class NewIdeasLocale {
  public data: {
    title: string;
    content: string;
    button: string;
  } = {
    title: "",
    content: "",
    button: "",
  };
  constructor() {
    const { locale } = useI18n();
    this.data =
      dataLocales.find((item) => item.locale == locale.value)?.data ??
      dataLocales[0].data;
  }
}
const dataLocales: Array<Revolutions> = [
  {
    locale: "en",
    data: {
      title: "Revolutionize Your <span class='down-mark-line'>Marketing</span>",
      content: `<p>We have a plethora of creative ideas for utilizing QR codes to help businesses, non-profit organizations, and cities better interact and connect with their customers. </p>
                <p>Our system provides you with the ability to create QR codes with various features, making it easier than ever to manage information and track access metrics.</p>
                <p>Additionally, we provide you with a comprehensive management interface, helping you efficiently manage large groups and businesses.</p>
                <p class="mt-4 text-lg md:text-xl ">Take advantage of this growing trend for your business now.</p>
        `,
      button: "QR Codes in Marketing",
    },
  },
  {
    locale: "vi",
    data: {
      title: "Cách Mạng Hóa <span class='down-mark-line'>Marketing</span>",
      content: `<p>Chúng tôi có vô số ý tưởng sáng tạo để sử dụng mã QR để giúp các doanh nghiệp, tổ chức phi lợi nhuận và các thành phố tương tác và kết nối tốt hơn với khách hàng của họ. </p> <p>Hệ thống của chúng tôi cung cấp cho bạn khả năng tạo mã QR với các tính năng khác nhau, giúp quản lý thông tin và theo dõi các chỉ số truy cập dễ dàng hơn bao giờ hết. </p> <p>Ngoài ra, chúng tôi cung cấp cho bạn một giao diện quản lý toàn diện, giúp bạn quản lý hiệu quả các nhóm và doanh nghiệp lớn.</p> <p class=“mt-4 text-lg md:text-xl ”>Tận dụng xu hướng phát triển này cho doanh nghiệp của bạn ngay bây giờ. </p>`,
      button: "Mã QR trong Marketing",
    },
  },
  {
    locale: "fr",
    data: {
      title:
        "Révolutionnez Votre <span class='down-mark-line'>Marketing</span>",
      content:
        "<p>Nous avons une pléthore d’idées créatives pour utiliser les codes QR afin d’aider les entreprises, les organisations à but non lucratif et les villes à mieux interagir et se connecter avec leurs clients. </p> <p>Notre système vous permet de créer des codes QR avec diverses fonctionnalités, ce qui facilite plus que jamais la gestion des informations et le suivi des métriques d’accès. </p> <p>De plus, nous vous fournissons une interface de gestion complète, vous aidant à gérer efficacement les grands groupes et les entreprises.</p> <p class=“mt-4 text-lg md:text-xl ”>Profitez dès maintenant de cette tendance croissante pour votre entreprise. </p>",
      button: "Codes QR dans le marketin",
    },
  },
  {
    locale: "it",
    data: {
      title: "Rivoluzionare il <span class='down-mark-line'>Marketing</span>",
      content: `<p>Abbiamo una miriade di idee creative per utilizzare i codici QR per aiutare le aziende, le organizzazioni senza scopo di lucro e le città a interagire e connettersi meglio con i propri clienti.</p>
        <p>Il nostro sistema ti offre la possibilità di
        creare
        Codici QR con varie funzionalità, che rendono più semplice che mai la gestione delle informazioni e il monitoraggio degli accessi
        metrica.
        </p>
        <p>Inoltre, ti forniamo un'interfaccia di gestione completa, che ti aiuta in modo efficiente
        maneggio
        grande
        gruppi e imprese.</p>
        <p class="mt-4 text-lg md:text-xl ">Approfitta subito di questa tendenza in crescita per la tua attività.
        </p>`,
      button: "I codici QR nel marketing",
    },
  },
  {
    locale: "es",
    data: {
      title: "Revolucione su <span class='down-mark-line'>Marketing</span>",
      content: `<p>Tenemos una plétora de ideas creativas para utilizar códigos QR para ayudar a empresas, organizaciones sin fines de lucro y ciudades a interactuar y conectarse mejor con sus clientes. </p>
      <p>Nuestro sistema le brinda la capacidad de crear códigos QR con varias funciones, lo que facilita más que nunca la administración de la información y el seguimiento de las métricas de acceso.</p>
      <p>Además, le brindamos una interfaz de administración integral, que lo ayuda a administrar de manera eficiente grandes grupos y empresas.</p>
      <p class="mt-4 text-lg md:text-xl ">Aproveche esta tendencia creciente para su negocio ahora.</p>`,
      button: "Códigos QR en Marketing",
    },
  },
  {
    locale: "pt",
    data: {
      title: "Revolucione seu <span class='down-mark-line'>Marketing</span>",
      content: `<p>Temos uma infinidade de ideias criativas para utilizar códigos QR para ajudar empresas, organizações sem fins lucrativos e cidades a interagir e se conectar melhor com seus clientes. </p>
      <p>Nosso sistema oferece a capacidade de criar códigos QR com vários recursos, tornando mais fácil do que nunca gerenciar informações e rastrear métricas de acesso.</p>
      <p>Além disso, fornecemos uma interface de gerenciamento abrangente, ajudando você a gerenciar com eficiência grandes grupos e empresas.</p>
      <p class="mt-4 text-lg md:text-xl ">Aproveite agora esta tendência crescente para o seu negócio.</p>
        `,
      button: "Códigos QR em Marketing",
    },
  },
  {
    locale: "nl",
    data: {
      title:
        "Breng een revolutie teweeg in uw <span class='down-mark-line'>Marketing</span>",
      content: `<p>We hebben een overvloed aan creatieve ideeën voor het gebruik van QR-codes om bedrijven, non-profitorganisaties en steden te helpen beter te communiceren en contact te maken met hun klanten. </p>
      <p>Ons systeem biedt u de mogelijkheid om QR-codes met verschillende functies te maken, waardoor het gemakkelijker dan ooit wordt om informatie te beheren en toegangsstatistieken bij te houden.</p>
      <p>Bovendien bieden we u een uitgebreide beheerinterface waarmee u grote groepen en bedrijven efficiënt kunt beheren.</p>
      <p class="mt-4 text-lg md:text-xl ">Profiteer nu van deze groeiende trend voor uw bedrijf.</p>
        `,
      button: "QR Codes in Marketing",
    },
  },
  {
    locale: "ja",
    data: {
      title: "<span class='down-mark-line'>マーケティング</span>に革命を",
      content: `<p>QR コードを利用して、企業、非営利団体、および都市が顧客とよりよくやり取りし、つながるのに役立つ創造的なアイデアがたくさんあります。 </p>
      <p>私たちのシステムは、さまざまな機能を備えた QR コードを作成する機能を提供し、情報の管理とアクセス メトリックの追跡をこれまで以上に簡単にします。</p>
      <p>さらに、大規模なグループやビジネスを効率的に管理するのに役立つ包括的な管理インターフェースを提供します。</p>
      <p class="mt-4 text-lg md:text-xl ">この成長トレンドを今すぐビジネスに活用してください。</p>
        `,
      button: "マーケティングにおけるQRコード",
    },
  },
  {
    locale: "de",
    data: {
      title:
        "Revolutionieren Sie Ihr <span class='down-mark-line'>Marketing</span>",
      content: `<p>Wir haben eine Fülle kreativer Ideen für die Verwendung von QR-Codes, um Unternehmen, gemeinnützige Organisationen und Städte dabei zu unterstützen, besser mit ihren Kunden zu interagieren und in Kontakt zu treten. </p>
      <p>Unser System bietet Ihnen die Möglichkeit, QR-Codes mit verschiedenen Funktionen zu erstellen, wodurch es einfacher denn je ist, Informationen zu verwalten und Zugriffsmetriken zu verfolgen.</p>
      <p>Zusätzlich stellen wir Ihnen eine umfassende Verwaltungsoberfläche zur Verfügung, mit der Sie große Gruppen und Unternehmen effizient verwalten können.</p>
      <p class="mt-4 text-lg md:text-xl ">Nutzen Sie jetzt diesen wachsenden Trend für Ihr Unternehmen.</p>
        `,
      button: "QR Codes im Marketing",
    },
  },
  {
    locale: "zh",
    data: {
      title: "彻底改变您的<span class='down-mark-line'>市场营销</span>",
      content:
        '<p>我们有大量创意思路，利用QR码帮助企业、非营利组织和城市更好地与客户互动和连接。</p> <p>我们的系统为您提供创建具有各种功能的QR码的能力，使信息管理和跟踪访问指标变得比以往更加容易。</p> <p>此外，我们为您提供全面的管理界面，帮助您高效管理大型群体和企业。</p> <p class="mt-4 text-lg md:text-xl ">立即抓住这一不断增长的趋势，为您的企业谋划更大发展。</p>',
      button: "QR码在营销中的应用",
    },
  },
];
